import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const SrTodayTooltip = ({ cy, cx }) => {
  return (
    <svg
      x={cx - 19}
      y={cy - 53}
      width="47"
      height="38"
      viewBox="0 0 47 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4V28C0 30.2091 1.79086 32 4 32H18L23.2929 37.2929C23.6834 37.6834 24.3166 37.6834 24.7071 37.2929L30 32H43C45.2091 32 47 30.2091 47 28V4C47 1.79086 45.2091 0 43 0H4Z"
        fill="#FFCE06"
      />
      <path
        d="M12.024 12.6002H6.58796C6.47996 12.6002 6.40796 12.6722 6.40796 12.7802V14.0642C6.40796 14.1722 6.47996 14.2442 6.58796 14.2442H8.37596V20.8202C8.37596 20.9282 8.44796 21.0002 8.55596 21.0002H10.056C10.164 21.0002 10.236 20.9282 10.236 20.8202V14.2442H12.024C12.132 14.2442 12.204 14.1722 12.204 14.0642V12.7802C12.204 12.6722 12.132 12.6002 12.024 12.6002Z"
        fill="#132630"
      />
      <path
        d="M15.0173 21.1562C16.7213 21.1562 18.0893 19.8002 18.0893 18.0722C18.0893 16.3442 16.7213 14.9882 15.0173 14.9882C13.3253 14.9882 11.9573 16.3442 11.9573 18.0722C11.9573 19.8002 13.3253 21.1562 15.0173 21.1562ZM15.0173 19.4882C14.2853 19.4882 13.6853 18.9002 13.6853 18.0722C13.6853 17.2442 14.2853 16.6562 15.0173 16.6562C15.7613 16.6562 16.3493 17.2442 16.3493 18.0722C16.3493 18.9002 15.7613 19.4882 15.0173 19.4882Z"
        fill="#132630"
      />
      <path
        d="M25.2668 12.2402H23.8268C23.7188 12.2402 23.6468 12.3122 23.6468 12.4202V15.6842C23.2388 15.2642 22.6988 14.9882 22.0628 14.9882C20.4308 14.9882 19.2308 16.3562 19.2308 18.0722C19.2308 19.7882 20.4308 21.1562 22.0628 21.1562C22.7828 21.1562 23.3348 20.8442 23.7428 20.3882L23.7788 20.8202C23.7908 20.9282 23.8508 21.0002 23.9588 21.0002H25.2668C25.3748 21.0002 25.4468 20.9282 25.4468 20.8202V12.4202C25.4468 12.3122 25.3748 12.2402 25.2668 12.2402ZM22.2908 19.5122C21.5228 19.5122 20.9588 18.8882 20.9588 18.0602C20.9588 17.2442 21.5228 16.6202 22.2908 16.6202C23.0468 16.6202 23.6108 17.2802 23.6108 18.0602C23.6108 18.8402 23.0468 19.5122 22.2908 19.5122Z"
        fill="#132630"
      />
      <path
        d="M32.8566 15.1202H31.5486C31.4406 15.1202 31.3806 15.1922 31.3686 15.3002L31.3326 15.7922C30.9126 15.3122 30.3486 14.9882 29.6526 14.9882C28.0206 14.9882 26.8206 16.3562 26.8206 18.0722C26.8206 19.7882 28.0206 21.1562 29.6526 21.1562C30.3726 21.1562 30.9246 20.8442 31.3326 20.3882L31.3686 20.8202C31.3806 20.9282 31.4406 21.0002 31.5486 21.0002H32.8566C32.9646 21.0002 33.0366 20.9282 33.0366 20.8202V15.3002C33.0366 15.1922 32.9646 15.1202 32.8566 15.1202ZM29.8806 19.5122C29.1126 19.5122 28.5486 18.8882 28.5486 18.0602C28.5486 17.2442 29.1126 16.6202 29.8806 16.6202C30.6366 16.6202 31.2006 17.2802 31.2006 18.0602C31.2006 18.8402 30.6366 19.5122 29.8806 19.5122Z"
        fill="#132630"
      />
      <path
        d="M40.4585 15.1202H38.9825C38.8865 15.1202 38.8025 15.1682 38.7665 15.2642L37.4465 18.8882L36.1265 15.2642C36.0905 15.1682 36.0065 15.1202 35.9105 15.1202H34.4585C34.3265 15.1202 34.2665 15.1922 34.3145 15.3242L36.5825 21.0122L35.7305 23.0762C35.6585 23.2082 35.7425 23.2802 35.8745 23.2802H37.2785C37.3745 23.2802 37.4585 23.2322 37.4945 23.1362L40.6025 15.3242C40.6505 15.1922 40.5905 15.1202 40.4585 15.1202Z"
        fill="#132630"
      />
    </svg>
  );
};
/* eslint-enable max-len */

SrTodayTooltip.propTypes = {
  cy: PropTypes.number.isRequired,
  cx: PropTypes.number.isRequired,
};

export default SrTodayTooltip;
